import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class ImportsQueriesService {
  public listImports(): DocumentNode {
    return gql`
      query listImports(
        $where: ImportWhereInput,
        $orderBy: ImportOrderByInput,
        $limit: Int,
        $offset: Int
      ) {
        imports(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          totalCount
          items {
            id
            type
            status
            createdAt
            createdBy {
              name
            }
          }
        }
      }
    `;
  }

  public getImportById(): DocumentNode {
    return gql`
      query import($id: ID!) {
        import(id: $id) {
          id
          type
          notes {
            errors {
              code
              reason
              properties
            }
            warnings {
              code
              reason
              properties
            }
          }
          status
          fileKey
          bucketName
          download {
            signedUrl
          }
          updateRowsCount
          createRowsCount
          deleteRowsCount
          validRowsCount
          invalidRowsCount
          totalRowsCount
          processedRowsCount
          createdAt
          updatedAt
          createdBy {
            name
            avatarUrl
          }
        }
      }
    `;
  }

  public generateUploadCredential(): DocumentNode {
    return gql`
      mutation generateUploadCredential($input: UploadCredentialInput!) {
        generateUploadCredential(input: $input) {
          baseUrl
          fields
          link
        }
      }
    `;
  }

  public createImport(): DocumentNode {
    return gql`
      mutation createImport($input: CreateImportInput!) {
        createImport(input: $input) {
          id
          updatedAt
        }
      }
    `;
  }

  public updateImportFile(): DocumentNode {
    return gql`
      mutation updateImportFile($input: UpdateImportFileInput!) {
        updateImportFile(input: $input) {
          id
          updatedAt
        }
      }
    `;
  }

  public startImportValidation(): DocumentNode {
    return gql`
      mutation startImportValidation($input: StartImportValidationInput!) {
        startImportValidation(input: $input) {
          id
          updatedAt
          language
        }
      }
    `;
  }

  public startImport(): DocumentNode {
    return gql`
      mutation startImport($input: StartImportInput!) {
        startImport(input: $input) {
          id
          language
        }
      }
    `;
  }
}
